import { cn } from '@/lib/cn';

export interface LogoProps {
  className?: string;
}

export function LogoWordmark({ className }: LogoProps) {
  return (
    <span
      className={cn(
        'select-none whitespace-nowrap font-sans text-lg font-black tracking-tight text-brand-600 dark:text-brand-200',
        className,
      )}
    >
      e&#8288;-&#8288;dialog
    </span>
  );
}

export function LogoMark({ className }: LogoProps) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex h-[30px] w-[30px] shrink-0 select-none items-center justify-center rounded-lg bg-brand-600 text-base font-black text-white',
        className,
      )}
    >
      e
    </span>
  );
}
